import React from "react";
import NavBar from "../../components/NavBar";
import AppFooter from "../../components/footer";
import { useSelector } from "react-redux";
import { decodeHtml } from "../../utils";
import { Container } from "@mui/material";
const TermsAndConditions = () => {
  const { isLoading, data } = useSelector((state) => state.settingReducer);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  return (
    <>
      <NavBar />

      <Container sx={{ mt: 16 }}>
        <div
          dangerouslySetInnerHTML={{
            __html: decodeHtml(data?.terms[currentLanguage]),
          }}
        ></div>
      </Container>

      <AppFooter bgcolor={true} />
    </>
  );
};
export default TermsAndConditions;
